import React, { useRef, useState, useEffect } from "react";

import useMessageBox from "@maxis/client-logic/hooks/useMessageBox";
import { clear } from "@maxis/client-logic/utils/controlsUtil";
import { validate } from "@maxis/client-logic/utils/validationUtil";
import { Button } from "../../InputControls";
import { Modal } from "../../ModalPopup";
// import { FormSection } from "@/components/PageLayout";
import { FormSection } from "../../PageLayout";
import uuid from "react-uuid";

const KanBanPopup = React.forwardRef((props, ref) => {
  /*
    파트너사 조회 팝업
  */
  const { alert } = useMessageBox();

  const [isNew, setIsNew] = useState();

  const refDialog1 = useRef();
  const hiddenValue = useRef({
    id: "",
    groupId: "",
  });

  useEffect(() => {
    controls.form.cboGroup.ref.current?.setDataBinding(props.orgGroups);
  }, [props.orgGroups]);

  React.useImperativeHandle(ref, () => ({
    showOpen(title, isNew = true, event) {
      setIsNew(isNew);
      if (event) controls.form.cboGroup.ref.current?.setValue(event.groupId);
      pageFunctions.showPopup(title, event);
    },
  }));

  const controls = {
    form: {
      cboGroup: {
        ref: useRef(),
        label: "Group",
        labelWidth: "wpx_180",
        validation: { required: true },
        controlOption: {
          valueId: "id",
          labelId: "title",
        },
      },
      txtContent: {
        ref: useRef(),
        label: "Content",
        labelWidth: "wpx_180",
        validation: { required: true },
      },
      txtValueNow: {
        ref: useRef(),
        label: "ValueNow",
        labelWidth: "wpx_180",
        validation: { required: true },
      },
    },
  };

  const pageFunctions = {
    showPopup: (title, event) => {
      if (event) {
        hiddenValue.current.id = event.id;
        hiddenValue.current.groupId = event.groupId;
        controls.form.txtContent.ref.current?.setValue(event.content);
        controls.form.txtValueNow.ref.current?.setValue(event.customData?.valueNow);
      }

      refDialog1.current?.setTitle(title);
      refDialog1.current?.showPopup();
    },
    closePopup: (data, delMode = false) => {
      clear(controls.form, true);

      if (props.callBackAction) {
        props.callBackAction(isNew, data, delMode);
      }

      refDialog1.current?.closePopup();
    },
    initForm: () => {
      hiddenValue.current.id = "";
      hiddenValue.current.groupId = "";
      refDialog1.current?.setTitle("");
      setIsNew(true);
      clear(controls.form, true);
    },
    onSave: async () => {
      try {
        if (validate(controls.form)) {
          const param = {
            groupId: controls.form.cboGroup.ref.current?.getValue(),
            content: controls.form.txtContent.ref.current?.getValue(),
            isDragDisabled: false,
            customData: { valueNow: controls.form.txtValueNow.ref.current?.getValue() },
            id: hiddenValue.current.id,
          };

          if (!param.id) {
            param.id = uuid();
            if (props.orgGroups.length === 0) {
              alert("", "정해진 그룹이 없습니다.");
              return;
            }
          }

          pageFunctions.closePopup(param);
        }
      } catch (e) {
        alert("", e.message);
      }
    },
    onDelete: async () => {
      const param = { id: hiddenValue.current.id, groupId: hiddenValue.current.groupId };
      pageFunctions.closePopup(param, true);
    },
  };

  return (
    <Modal
      ref={refDialog1}
      defaultTitle={"등록"}
      leftButtons={
        <>
          <Button
            label={"저장"}
            onClick={() => {
              pageFunctions.onSave();
            }}
          />
          {isNew ? null : (
            <Button
              label={"삭제"}
              onClick={() => {
                pageFunctions.onDelete();
              }}
            />
          )}
        </>
      }
      closeBtnEvent={() => {
        pageFunctions.closePopup();
      }}
      endEvent={() => {
        pageFunctions.initForm();
      }}
      defaultHeight="450px"
      defaultWidth="600px"
    >
      <FormSection formControls={controls.form} numOfCols={1} checkAuth={true} />
    </Modal>
  );
});

export default KanBanPopup;
